"use client";

import { useStats } from "react-instantsearch";

export function CustomStats() {
  const { hitsPerPage, nbHits, page } = useStats();

  const currentPage = page + 1;
  const totalDisplayed = Math.min(hitsPerPage ?? 0 * currentPage, nbHits);

  return (
    <div className="text-[14px] truncate">
      Mostrando {totalDisplayed} de {nbHits} resultados
    </div>
  );
}
